import React from 'react';
import Button from '@atlaskit/button';
import { emptyStateImgLink } from '@css-xp/ppc-common/src/constant';

import './no-billing-profile.scss';

export const ErrorEntitlement = ({ handleRefetchEntitlements }: { handleRefetchEntitlements?: () => void }) => {
  return (
    <div className="flex-column justify-center align-center no-entitlement pa-32">
      {/* @ts-ignore */}
      <img src={emptyStateImgLink} alt="Error occurred" width="56px" height="52px" />
      <p className="no-entitlement-description mt-16">Couldn't fetch subscriptions</p>
      {handleRefetchEntitlements && (
        <Button appearance="primary" className="mt-16" onClick={() => handleRefetchEntitlements()}>
          Retry
        </Button>
      )}
    </div>
  );
};
